import { render, staticRenderFns } from "./Excludedate.vue?vue&type=template&id=87c4715e&"
import script from "./Excludedate.vue?vue&type=script&lang=ts&"
export * from "./Excludedate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports